/**
 * Class responsible for managing form operations such as clearing input fields
 * and toggling the state of the send button in a form.
 */
export class FormManager {
    
    /**
     * Clears all input, textarea, and select values from the specified form.
     *
     * @param formId - The ID of the form to clear values from.
     */
    public clearForm(formId: string): void {
        const form = document.getElementById(formId) as HTMLFormElement | null;

        if (!form) return;

        const inputFields = form.querySelectorAll<HTMLInputElement>(
            'input:not([type="hidden"]):not([type="submit"]):not([type="file"])'
        );
        const textareas = form.querySelectorAll<HTMLTextAreaElement>("textarea");
        const selects = form.querySelectorAll<HTMLSelectElement>("select");
        const fileInputs = form.querySelectorAll<HTMLInputElement>('input[type="file"]');

        inputFields.forEach((input) => (input.value = ""));

        textareas.forEach((textarea) => (textarea.value = ""));

        selects.forEach((select) => {
            select.value = "";

            // @ts-ignore
            if (typeof window.$ !== "undefined" && window.$(select).hasClass("select2-hidden-accessible")) {
                // @ts-ignore
                window.$(select).val(null).trigger("change");
            }
        });

        fileInputs.forEach((input) => {

            const fileUpload = input.closest(".file-upload");

            if (fileUpload) {
                fileUpload.setAttribute("data-state", "empty");
                const fileUploadFiles = fileUpload.querySelector(".file-upload__files");

                if (fileUploadFiles) {
                    fileUploadFiles.innerHTML = "";
                }
            }

            input.value = "";
        });
    }
}